import { render, staticRenderFns } from "./createuserinfo.vue?vue&type=template&id=1e70791e&scoped=true&"
import script from "./createuserinfo.vue?vue&type=script&lang=js&"
export * from "./createuserinfo.vue?vue&type=script&lang=js&"
import style0 from "./createuserinfo.vue?vue&type=style&index=0&id=1e70791e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e70791e",
  null
  
)

export default component.exports